import { AnnotationModel } from "../plan/models/annotation.model";

const annotationIconDefId = "annotation-icon";
const annotationLayerId = "annotation-layer";
const svgLibPlanElementId = "dessin";
const BASE_ICON_SCALE = 10;

const inlineSvgContent = (rootElement: Element, svgContent: string) => {
  rootElement.innerHTML = "";
  rootElement.insertAdjacentHTML("beforeend", svgContent);
};

const createSvgAnnotationIconDef = (rootElement: Element) => {
  const svg = rootElement.querySelector("svg")!;
  if (!svg.querySelector(`#${annotationIconDefId}`)) {
    const iconDef = `
    <defs>
        <g id="${annotationIconDefId}" fill-opacity="1" stroke="none">
            <g transform="translate(-7.5,-20)">
                <path d="m11.223 8.645-.438-4.234h1.512a.86.86 0 0 0 .859-.86V1.833a.86.86 0 0 0-.86-.86H2.558a.86.86 0 0 0-.86.86V3.55c0 .475.385.86.86.86h1.511L3.63 8.645C1.893 9.453.552 10.901.552 12.718c0 .475.385.86.86.86H6.28v3.724c0 .044.01.088.03.128l.86 1.718c.105.211.407.211.512 0l.86-1.718c.02-.04.03-.084.03-.128v-3.725h4.87a.86.86 0 0 0 .859-.86c0-1.832-1.36-3.273-3.079-4.072Z" />
            </g>
        </g>
    </defs>`;
    svg.insertAdjacentHTML("afterbegin", iconDef.trim());
  }
};

const createSvgAnnotationLayer = (rootElement: Element) => {
  if (!rootElement.querySelector(`#${annotationLayerId}`)) {
    const parent = rootElement.querySelector(`#${svgLibPlanElementId}`)!;
    const layer = `<g id="annotation-layer" />`;
    parent.insertAdjacentHTML("beforeend", layer.trim());
  }
};

const updateSvgAnnotationLayerContent = (
  rootElement: Element,
  annotations: AnnotationModel[],
  clickHandler: (annotation: AnnotationModel) => void
) => {
  const annotationLayer = rootElement.querySelector(`#${annotationLayerId}`)!;
  annotationLayer.innerHTML = "";
  annotations.forEach((annotation) => {
    const annotationIcon = `<use
        href="#${annotationIconDefId}"
        x="${annotation.x}"
        y="${annotation.y}"
        fill="${annotation.getColor()}"
        opacity="${annotation.getOpacity()}"
    />`;
    const noPropagationHandler = (event: Event) => {
      event.stopPropagation();
      clickHandler(annotation);
    };
    annotationLayer.insertAdjacentHTML("beforeend", annotationIcon.trim());
    annotationLayer.lastElementChild!.addEventListener("mousedown", noPropagationHandler);
  });
};

const computeSvgScale = (rootElement: Element) => {
  const svg = rootElement.querySelector("svg")!;
  return svg.getBoundingClientRect().height / svg.viewBox.baseVal.height;
};

const updateSvgAnnotationIconDefScale = (rootElement: Element, iconScale: number) => {
  if (!isFinite(iconScale)) {
    return;
  }
  const iconDef = rootElement.querySelector(`#${annotationIconDefId}`)!;
  iconDef.setAttribute("transform", `scale(${BASE_ICON_SCALE * iconScale},-${BASE_ICON_SCALE * iconScale})`);
};

const loadSvg = (rootElement: Element, svgContent: string) => {
  inlineSvgContent(rootElement, svgContent);
  createSvgAnnotationIconDef(rootElement);
  createSvgAnnotationLayer(rootElement);
  
 requestAnimationFrame(() => {
    scaleSvgAnnotations(rootElement);
  });
  
  svgLoad(null, 1);
};

const updateSvgAnnotations = (
  rootElement: Element,
  annotations: AnnotationModel[],
  clickHandler: (annotation: AnnotationModel) => void
) => {
  updateSvgAnnotationLayerContent(rootElement, annotations, clickHandler);
  scaleSvgAnnotations(rootElement);
};

const scaleSvgAnnotations = (rootElement: Element) => {
  const currentScale = computeSvgScale(rootElement);
  updateSvgAnnotationIconDefScale(rootElement, currentScale);
};

export { loadSvg, updateSvgAnnotations, scaleSvgAnnotations };
